import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import type { UserDto } from '@/api/types';

interface SessionState {
  user: UserDto | null;
  accessToken: string | null;
  refreshToken: string | null;
  set: (user: UserDto, accessToken: string, refreshToken: string) => void;
  clear: () => void;
}

export const useSessionStore = create<SessionState>()(
  persist(
    (set) => ({
      user: null,
      accessToken: null,
      refreshToken: null,
      set: (user, accessToken, refreshToken) => set({ user, accessToken, refreshToken }),
      clear: () => set({ user: null, accessToken: null, refreshToken: null }),
    }),
    { name: 'nocturnal-surveys-session' },
  ),
);
